/** 官网收款页用的小壳：右侧抽屉 / 居中弹窗（Tailwind animate-in 动效，铁律十七）+ 错误文案。 */
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { ApiError } from "@/services/api";

export function errText(e: unknown): string {
  if (e instanceof ApiError || e instanceof Error) return e.message || "操作失败，请重试";
  return "操作失败，请重试";
}

function useEscape(onClose: () => void) {
  useEffect(() => {
    const h = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);
}

export function Drawer({ title, onClose, children }: { title: React.ReactNode; onClose: () => void; children: React.ReactNode }) {
  useEscape(onClose);
  return createPortal(
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-slate-900/35 backdrop-blur-[2px] animate-in fade-in" onClick={onClose} aria-hidden />
      <aside role="dialog" aria-modal="true" className="relative flex h-full w-[min(440px,100vw)] flex-col gap-3.5 overflow-y-auto bg-white p-5 shadow-2xl animate-in slide-in-from-right">
        <div className="flex items-center gap-2">
          <h3 className="text-[16px] font-semibold">{title}</h3>
          <button type="button" aria-label="关闭" onClick={onClose} className="ml-auto text-[18px] text-slate-400 hover:text-slate-700">✕</button>
        </div>
        {children}
      </aside>
    </div>,
    document.body,
  );
}

export function Modal({ title, onClose, children }: { title: React.ReactNode; onClose: () => void; children: React.ReactNode }) {
  useEscape(onClose);
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-start justify-center pt-[18vh]">
      <div className="absolute inset-0 bg-slate-900/35 backdrop-blur-[2px] animate-in fade-in" onClick={onClose} aria-hidden />
      <div role="dialog" aria-modal="true" className="relative flex w-[420px] max-w-[calc(100%-32px)] flex-col gap-3 rounded-2xl bg-white p-5 shadow-2xl animate-in zoom-in-95 slide-in-from-bottom-4">
        <h3 className="text-[16px] font-semibold">{title}</h3>
        {children}
      </div>
    </div>,
    document.body,
  );
}
